import React, { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import axios from "axios";
import api from "constants/api";
import NcImage from "shared/NcImage/NcImage";
import SkewLoader from "react-spinners/SkewLoader";
import ProductCard from "components/ProductCard";
import Heading from "components/Heading/Heading";

interface Category {
    _id: string;
    name: string;
    slug: string;
    image_data?: {
        pathname: string;
    };
    special_price_product?: string;
}

const SpecialPricePage: FC = () => {
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState<Category[]>([]);

    useEffect(() => {
        fetchSpecialCategories();
    }, []);

    const fetchSpecialCategories = async () => {
        setLoading(true);
        try {
            const url = process.env.REACT_APP_API_URL + api.frontCategory;
            const res = await axios.post(url, {});

            if (res.data.statusCode === 200) {
                const allCategories = res.data.data.category;

                const specialCategories = allCategories.filter(
                    (cat: Category) =>
                        cat.special_price_product?.trim().toLowerCase() === "present"
                );

                setCategories(specialCategories);
            }
        } catch (error) {
            console.error("Category fetch error:", error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="nc-SpecialPricePage">
            <Helmet>
                <title>Special Price | Vijaydeep</title>
            </Helmet>

            {loading && (
                <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
                    <SkewLoader color="#2A3491" />
                </div>
            )}

            <div className="container py-16 lg:pb-28 lg:pt-20 space-y-16">
                {/* 🔹 CATEGORY SECTION */}
                <div>
                    <Heading>Special Price Categories</Heading>

                    <div className="nc-Card13 grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 sm:gap-6 xl:gap-8 mt-6">
                        {categories.map((item) => (
                            <Link
                                key={item._id}
                                to={`/special-price/${item.slug}`}
                                className="block cursor-pointer hover:opacity-80 transition-opacity"
                            >
                                <NcImage
                                    className="rounded-2xl"
                                    src={`${process.env.REACT_APP_CLOUD_FRONT_URL}/${item.image_data?.pathname}`}
                                />

                                <div className="space-y-1 px-2.5 pt-5 pb-2.5">
                                    <h2 className="md:text-base text-sm font-semibold">
                                        {item.name}
                                    </h2>
                                    <span className="block text-secondary-900 text-sm">
                                        View Products
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecialPricePage;